import { createContext } from 'react';

interface ITextCopyContext {
  getTextCopy: (text: string) => string;
}

export const TextCopyContextStub: ITextCopyContext = {
  getTextCopy: () => '',
};

export const TextCopyContext = createContext<ITextCopyContext>(TextCopyContextStub);
